import { render } from "./FilterCourse.vue?vue&type=template&id=1922aa89"
import script from "./FilterCourse.vue?vue&type=script&lang=js"
export * from "./FilterCourse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__